import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  animations: [
    trigger('openClose', [
      transition(':enter', [style({ opacity: 0 }), animate('300ms ease-in', style({ opacity: 1 }))]),
      transition(':leave', [animate('200ms ease-out', style({ opacity: 0 }))]),
    ]),
  ],
})
export class SidenavComponent implements OnInit, OnDestroy {

  public currentUserRole(role): boolean {
    //return this.authenticationService.currentUser.entityTypeSk;
    //return this.authenticationService.operator;
    return this.authenticationService.checkGroupsStr(role);
  }

  private readonly complete$ = new Subject();

  public activeMenu: string;

  public menus: {
    key: string;
    label: Observable<string>;
    role?: string;
    route?: string;
    submenu?: { key: string; label: Observable<string>; role?: string; route: string }[];
  }[] = [
    // TODO: If deployed like this, remove the routes (they are valid)
    {
      role: 'CONSULT',
      key: 'HomePage',
      label: this.translate.stream('sidenav.home'),
      route: '/home',
    },
    {
      role: 'CONSULT',
      key: 'Partners',
      label: this.translate.stream('sidenav.Partners'),
      route: '/partners',
    },
    {
      role: 'CONSULT',
      label: this.translate.stream('sidenav.Products'),
      key: 'Products',
      submenu: [
        {
          role: 'CONSULT',
          label: this.translate.stream('sidenav.Products&Offers'),
          key: 'Products & Offers',
          route: '/products',
        },
        {
          role: 'CONSULT',
          label: this.translate.stream('sidenav.Bundles'),
          key: 'Bundles',
          route: '/bundles',
        },
        {
          role: 'CONSULT',
          label: this.translate.stream('sidenav.Packages'),
          key: 'Packages',
          route: '/packages',
        },
        /*{
          role: 'TIMWE',
          label: this.translate.stream('sidenav.Campaigns'),
          key: 'Campaigns',
          route: '/campaigns',
        }*/
      ],
    },
    {
      role: 'CONSULT',
      label: this.translate.stream('sidenav.Vouchers'),
      key: 'Vouchers',
      route: '/vouchers'
    },
    {
      role: 'CONSULT',
      label: this.translate.stream('sidenav.massiveConfigurations'),
      key: 'massiveConfigurations',
      submenu: [
        {
          role: 'CONSULT',
          label: this.translate.stream('sidenav.State'),
          key: 'State',
          route: '/massive-configurations/state',
        }
      ],
    },
    {
      role: 'CONSULT',
      label: this.translate.stream('sidenav.Reports'),
      key: 'Reports',
      submenu: [
        {
          role: 'CONSULT',
          label: this.translate.stream('sidenav.Dashboard'),
          key: 'Dashboard',
          route: '/reporting',
        },
        /*{
          role: 'CONSULT',
          label: this.translate.stream('sidenav.Analytics'),
          key: 'Analytics',
          route: '/analytics',
        },*/
      ],
    },
    {
      role: 'CONSULT',
      key: 'Approvals',
      label: this.translate.stream('sidenav.Approvals'),
      submenu: [
        {
          role: 'CONSULT',
          label: this.translate.stream('sidenav.massiveConfigurations'),
          key: 'MassiveConfigurationApprove',
          route: '/massive-configurations/approve',
        },
        {
          role: 'invisible',
          label: this.translate.stream('sidenav.Partners'),
          key: 'Partners',
          route: '/approvals-partners',
        },
        {
          role: 'invisible',
          label: this.translate.stream('sidenav.ProductOffers'),
          key: 'ProductOffers',
          route: '/approvals-product-offers',
        }
      ],
    },
    {
      role: 'invisible',
      key: 'Administration',
      label: this.translate.stream('sidenav.Administration'),
      submenu: [
        {
          label: this.translate.stream('sidenav.plans'),
          key: 'plans',
          route: '/partners/employer-plans',
        }
      ],
    },
    {
      role: 'invisible',
      label: this.translate.stream('sidenav.Settlement'),
      key: 'Settlement',
      submenu: [
        {
          label: this.translate.stream('sidenav.Reconciliation'),
          key: 'Reconciliation',
          route: '/reconciliation',
        },
        {
          label: this.translate.stream('sidenav.Settlement'),
          key: 'Settlement',
          route: '/settlement',
        },
        {
          label: this.translate.stream('sidenav.Payments'),
          key: 'Payments',
          route: '/payments',
        },
        // {
        //   label: this.translate.stream('sidenav.MonthlyPaymentSummary'),
        //   key: 'Monthly Payment Summary',
        //   route: '/monthly-payment-summary',
        // },
        // {
        //   label: this.translate.stream('sidenav.MonthlySettlementSummary'),
        //   key: 'Monthly Settlement Summary',
        //   route: '/monthly-settlement-summary',
        // },
        // {
        //   label: this.translate.stream('sidenav.TransactionsDetail'),
        //   key: 'Transactions Detail',
        //   route: '/transactions',
        // },
      ],
    },
    {
      role: 'invisible',
      key: 'Reporting',
      label: this.translate.stream('sidenav.Reporting'),
      route: '/reporting',
      // submenu: [
      //   {
      //     key: 'Dashboard',
      //     label: this.translate.stream('sidenav.Dashboard'),
      //     route: '/dashboard',
      //   },
      //   {
      //     key: 'Analytics',
      //     label: this.translate.stream('sidenav.Analytics'),
      //     route: '/analytics',
      //   },
      //   {
      //     role: 'OPERATOR',
      //     key: 'Monitoring',
      //     label: this.translate.stream('sidenav.Monitoring'),
      //     route: '/monitoring',
      //   },
      //   {
      //     key: 'Anti Fraud',
      //     label: this.translate.stream('sidenav.AntiFraud'),
      //     route: '/anti-fraud',
      //   },
      // ],
    },
    {
      role: 'invisible',
      key: 'Tiketing',
      label: this.translate.stream('sidenav.Ticketing'),
      route: '/ticketing',
    },
    {
      role: 'invisible',
      label: this.translate.stream('sidenav.Documentation'),
      key: 'Documentation',
      route: '/documentation'
    },
    // {
    //   role: 'PARTNER',
    //   key: 'Profile',
    //   label: this.translate.stream('sidenav.Profile'),
    //   route: `/partners/${this.authenticationService.currentUser.entityId}/view`,
    // },
    // {
    //   label: this.translate.stream('sidenav.Documentation'),
    //   key: 'Documentation',
    //   route: '/documents',
    // },
    // {
    //   role: 'invisible',
    //   label: this.translate.stream('sidenav.Communication'),
    //   key: 'Communication',
    //   submenu: [
    //     {
    //       label: this.translate.stream('sidenav.Incentives'),
    //       key: 'Incentives',
    //       route: '/communication/incentives',
    //     },
    //   ],
    // },
    // {
    //   role: 'OPERATOR',
    //   key: 'Admin',
    //   label: this.translate.stream('sidenav.Admin'),
    //   submenu: [
    //     {
    //       label: this.translate.stream('sidenav.BusinessConsole'),
    //       key: 'Business Console',
    //       route: '/admin/business-console',
    //     },
    //   ],
    // },
    // {
    //   key: 'User Management',
    //   role: 'OPERATOR',
    //   label: this.translate.stream('sidenav.UserManagement'),
    //   submenu: [
    //     {
    //       label: this.translate.stream('sidenav.Users'),
    //       key: 'ManageUser',
    //       route: '/user-management/manage-users',
    //     },
    //     {
    //       label: this.translate.stream('sidenav.Teams'),
    //       key: 'Teams',
    //       route: '/user-management/teams',
    //     },
    //   ],
    // },
  ];

  public openMenu: string;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router,
    private readonly translate: TranslateService
  ) {}

  public ngOnDestroy() {
    this.complete$.next();

    this.complete$.complete();
  }

  public ngOnInit() {
    this.router.events.pipe(takeUntil(this.complete$)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setActiveMenu(event.url);
      }
    });
  }

  public setActiveMenu(routeNameOrUrl: string): void {
    const activeMenu = this.menus.find(
      menu => menu.submenu && menu.submenu.find(submenu => routeNameOrUrl.toLowerCase().startsWith(submenu.route))
    );

    if (activeMenu) {
      this.activeMenu = activeMenu.key;
    } else {
      this.activeMenu = routeNameOrUrl;
    }

    this.openMenu = this.activeMenu;
  }

  public setOpenMenu(menu: string): void {
    if (this.openMenu === menu) {
      this.openMenu = null;
    } else {
      this.openMenu = menu;
    }
  }
}
